"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.samlCallbackSchema = exports.refreshTokenSchema = exports.totpDisableSchema = exports.totpVerifySchema = exports.totpEnableSchema = exports.invitationCheckSchema = exports.invitationAcceptSchema = exports.magicLinkConsumeSchema = exports.magicLinkRequestSchema = exports.roleSchema = void 0;
const zod_1 = require("zod");
// Roles
exports.roleSchema = zod_1.z.enum([
    "CUSTOMER",
    "STAFF",
    "SALES",
    "REVIEWER",
    "PROVISIONER",
    "ADMIN",
]);
// Magic Link Request
// Trimmed and lowercased before validation: "  Ada@Example.COM " → "ada@example.com".
exports.magicLinkRequestSchema = zod_1.z.object({
    email: zod_1.z.string().trim().toLowerCase().email("Invalid email address"),
});
// Magic Link Consume
exports.magicLinkConsumeSchema = zod_1.z.object({
    token: zod_1.z.string().min(1, "Token is required"),
});
// Invitation Accept
exports.invitationAcceptSchema = zod_1.z.object({
    token: zod_1.z.string().min(1, "Token is required"),
    name: zod_1.z.string().min(2, "Name must be at least 2 characters").optional(),
});
// Invitation Check (verify token and check if user exists)
exports.invitationCheckSchema = zod_1.z.object({
    token: zod_1.z.string().min(1, "Token is required"),
});
// TOTP Enable — server generates the secret and returns it (plus the
// otpauth:// URI for QR rendering). Client holds the secret in memory until
// the verify step completes.
exports.totpEnableSchema = zod_1.z.object({});
// TOTP Verify — client echoes the secret back with the code to avoid needing
// a server-side "pending TOTP" store. We only persist the secret after a
// successful code match.
exports.totpVerifySchema = zod_1.z.object({
    code: zod_1.z.string().length(6, "Code must be 6 digits"),
    secret: zod_1.z.string().min(1).optional(),
});
// TOTP Disable — only requires the current code; secret comes from DB.
exports.totpDisableSchema = zod_1.z.object({
    code: zod_1.z.string().length(6, "Code must be 6 digits"),
});
// Refresh Token
exports.refreshTokenSchema = zod_1.z.object({
    refreshToken: zod_1.z.string().min(1),
});
// SAML Authentication
exports.samlCallbackSchema = zod_1.z.object({
    SAMLResponse: zod_1.z.string().min(1),
    RelayState: zod_1.z.string().optional(),
});
